/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_SchedulerService_Dtos_TimeZone_TimeZoneDto } from '../models/Wealthlane_SchedulerService_Dtos_TimeZone_TimeZoneDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TimeZoneService {

    /**
     * @returns Wealthlane_SchedulerService_Dtos_TimeZone_TimeZoneDto OK
     * @throws ApiError
     */
    public static getApiSchedulerApiAppTimeZoneTimeZoneList(): CancelablePromise<Array<Wealthlane_SchedulerService_Dtos_TimeZone_TimeZoneDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/scheduler/api/app/time-zone/time-zone-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
